import React, { useState } from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreHorizRounded from '@mui/icons-material/MoreHorizRounded';

// New UI: a row's actions as one button for its next step, an optional quiet link, and a ⋯ menu for the rest
// (docs/ui_redesign/14-screen-concepts.md, Invoice models option A). Each action calls the screen's own handler with
// the same row id and mode its Classic link carries (data-rowid, data-mode), so the handlers run unchanged.
export const linkEvent = (rowId, mode) => ({
	preventDefault() {}, stopPropagation() {},
	target: { dataset: { rowid: String(rowId), mode: mode || '' } },
	currentTarget: { dataset: { rowid: String(rowId), mode: mode || '' } }
});

export default function RowActions({ rowId, primary, link, more = [], label }) {
	const [anchor, setAnchor] = useState(null);
	const run = a => e => { if (e) { e.preventDefault(); e.stopPropagation(); } setAnchor(null); a.onClick(linkEvent(rowId, a.mode)); };
	return (
		<div className="apw2-rowacts">
			{primary && <button type="button" className="apw2-rowbtn" onClick={run(primary)}>{primary.label}</button>}
			{link && <button type="button" className="apw2-rowlink" onClick={run(link)}>{link.label}</button>}
			{more.length > 0 && (
				<>
					<button type="button" className="apw2-rowmore" aria-label={`More actions${label ? ' for ' + label : ''}`} aria-haspopup="menu" aria-expanded={!!anchor}
						onClick={e => { e.stopPropagation(); setAnchor(e.currentTarget); }}>
						<MoreHorizRounded fontSize="small" />
					</button>
					<Menu anchorEl={anchor} open={!!anchor} onClose={() => setAnchor(null)} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
						transformOrigin={{ vertical: 'top', horizontal: 'right' }} slotProps={{ paper: { className: 'apw2-rowmenu' } }}>
						{more.map(a => <MenuItem key={a.label} onClick={run(a)}>{a.label}</MenuItem>)}
					</Menu>
				</>
			)}
		</div>
	);
}
